export const CartoonDollar = ({ size = 120, className = "", id = "cd", solid }) => (
  <svg width={size} height={size * 1.25} viewBox="0 0 100 125" className={className} aria-hidden="true">
    <defs>
      <linearGradient id={`${id}-fill`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#FFFFFF" />
        <stop offset="100%" stopColor="#FBCFE8" />
      </linearGradient>
    </defs>
    <text
      x="50" y="98"
      textAnchor="middle"
      fontFamily="'Arial Black', 'Helvetica Neue', Impact, sans-serif"
      fontWeight="900"
      fontSize="120"
      fill={solid || `url(#${id}-fill)`}
      stroke={solid || "#2A0A21"}
      strokeWidth="8"
      strokeLinejoin="round"
      paintOrder="stroke fill"
    >$</text>
  </svg>
);
